import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { installAxiosInterceptor } from './api/axiosConfig';
import Header from './components/Header';
import Footer from './components/Footer';

// Install global Bearer-token interceptor before any API call is made
installAxiosInterceptor();
import ContactWidget from './components/ContactWidget';
import { Toaster } from './components/ui/toaster';
import Inicio from './pages/Inicio';
import Nosotros from './pages/Nosotros';
import Servicios from './pages/Servicios';
import ServicioPLD from './pages/ServicioPLD';
import ISO from './pages/ISO';
import Equipo from './pages/Equipo';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import Contacto from './pages/Contacto';
import AvisoPrivacidad from './pages/AvisoPrivacidad';
import Whitepaper from './pages/Whitepaper';
import GobiernoCorporativo from './pages/GobiernoCorporativo';
import Editor from './pages/Editor';
import Noticias from './pages/Noticias';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <Header />
          <main className="pt-20">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Inicio />} />
              <Route path="/nosotros" element={<Nosotros />} />
              <Route path="/servicios" element={<Servicios />} />
              <Route path="/pld" element={<ServicioPLD />} />
              <Route path="/iso" element={<ISO />} />
              <Route path="/equipo" element={<Equipo />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/noticias" element={<Noticias />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/aviso-de-privacidad" element={<AvisoPrivacidad />} />
              <Route path="/whitepaper" element={<Whitepaper />} />
              <Route path="/gobierno-corporativo" element={<GobiernoCorporativo />} />
              <Route path="/editor" element={<Editor />} />
            </Routes>
          </main>
          <Footer />
          <ContactWidget />
          <Toaster />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
